import * as React from 'react';
export const IcUdderOff = (
  props: React.SVGProps<SVGSVGElement>
): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M3.44 14.75a2 2 0 00-.33 1.9L14.76 5H3a1 1 0 00-1 1 10 10 0 002.85 7l-1.41 1.75zM19.15 13A10 10 0 0022 6a1 1 0 00-1-1h-.59l.3-.29a1.004 1.004 0 10-1.42-1.42l-16 16a1 1 0 000 1.42.998.998 0 001.42 0l5-5 .31.08V19a2 2 0 104 0v-3.2c.626-.13 1.238-.318 1.83-.56l1.61 2A1.999 1.999 0 0019 18a2 2 0 001.56-3.25L19.15 13z'
      fill='currentColor'
    />
  </svg>
);
